<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Quiz Logo"
          class="shrink mr-2"
          contain
          src="./assets/logo.png"
          transition="scale-transition"
          width="40"
        />
        <v-img
          alt="Quiz Title"
          class="shrink mr-2"
          contain
          src="./assets/logo.svg"
          transition="scale-transition"
          width="120"
        />

      </div>

      <v-spacer></v-spacer>

      <PictureMenu/>
      <UserSelector/>
      <AdminMenu />

    </v-app-bar>

    <v-main>
      <QuizPage/>
    </v-main>

    <v-footer padless color="transparent" absolute>
      <v-col
          class="text-right"
          cols="12"
      >
        <v-btn
            href="https://cmatts.co.uk"
            target="_blank"
            text
        >
          <span class="mr-2">&copy; {{ new Date().getFullYear() }} Calvin Matthews</span>
        </v-btn>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import QuizPage from '@/components/QuizPage';
import AdminMenu from "@/components/AdminMenu";
import UserSelector from "@/components/UserSelector";
import PictureMenu from "@/components/PictureMenu";

export default {
  name: 'App',
  components: {
    PictureMenu,
    UserSelector,
    AdminMenu,
    QuizPage,
  },
  data() {
    return {
      poller: null
    };
  },
  mounted() {
    this.getGameStatus();
    this.poller = setInterval(this.getGameStatus, 600)
  },
  beforeDestroy() {
    clearInterval(this.poller);
  },
  methods: {
    ...mapActions(['getGameStatus']),
  },
};
</script>
